import {Service} from "../interface/service";

export interface Components {
    elements:any,
    class:any,
    componentName?:string,
    callback?:(component:any) => any
}

export class ComponentService implements Service {

    components:Components[] = [];

    addComponent(elements:any, component:any, componentName?:string, callback?:(component:any) => any) {
        this.components.push({ elements: elements, componentName: componentName, class: component, callback:callback});
    }

    getComponents():Components[] {
        return this.components;
    }
}